module.exports = __webpack_public_path__ + "img/kefu2.8bee4b6f.jpg";